import debug from 'debug';

// eslint-disable-next-line testing-library/no-debugging-utils
export default debug('gcs-browser-upload');
